var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSycamoreIcons07(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 170,
    viewBox: "0 0 128.000000 128.000000",
    preserveAspectRatio: "xMidYMid meet",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,128.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M223 1270 c-12 -5 -30 -21 -40 -37 -17 -25 -18 -66 -21 -558 -2 -291 0 -549 3 -573 3 -23 17 -55 30 -70 l23 -27 254 -3 c153 -2 265 1 281 7 49 19 62 54 66 183 l3 118 133 0 c108 0 137 3 149 16 14 13 16 49 16 241 l0 225 -82 84 -82 84 -68 0 -68 0 0 103 c0 186 -18 212 -149 212 -79 0 -86 -2 -86 -20 0 -18 8 -20 75 -23 41 -2 80 -8 87 -14 9 -7 13 -45 13 -134 l0 -124 -69 0 c-54 0 -70 -4 -75 -16 -3 -9 -6 -148 -6 -309 0 -340 -4 -325 91 -325 59 0 59 0 59 -30 l0 -30 -270 0 -270 0 0 479 c0 379 3 481 13 489 7 6 46 12 87 14 67 3 75 5 75 23 0 18 -7 20 -75 22 -41 1 -85 -2 -97 -7z m687 -419 c0 -78 13 -91 91 -91 l59 0 0 -200 0 -200 -195 0 -195 0 0 275 0 275 120 0 120 0 0 -59z m110 -33 c0 -4 -11 -8 -25 -8 -21 0 -25 5 -25 32 l0 31 25 -23 c14 -13 25 -27 25 -32z m-260 -681 c0 -36 -5 -68 -12 -75 -17 -17 -499 -17 -516 0 -7 7 -12 39 -12 75 l0 63 270 0 270 0 0 -63z",
    fill: "#BB9C64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424 135 c-11 -27 10 -36 72 -33 51 3 59 6 59 23 0 18 -8 20 -63 23 -50 2 -63 0 -68 -13z",
    fill: "#BB9C64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473 1264 c-8 -21 13 -42 28 -27 13 13 5 43 -11 43 -6 0 -13 -7 -17 -16z",
    fill: "#BB9C64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394 1115 c-11 -29 11 -36 102 -33 81 3 89 5 89 23 0 18 -8 20 -93 23 -77 2 -93 0 -98 -13z",
    fill: "#BB9C64"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSycamoreIcons07);
export default __webpack_public_path__ + "static/media/Sycamore Icons-07.c73f851e.svg";
export { ForwardRef as ReactComponent };